export default "__VITE_ASSET__DCoxvija__"